<template>
  <div
    class="player-container"
    id="homePlayer"
  >
    <div v-if="!isVideoDel">
      <player
        :iscover="iscover"
        :playUrl="playUrl"
        :pic="coverUrl"
        @playing="playerPlay"
        @ended="playerEnd"
        @waiting="clearReportVideoView"
        @pause="clearReportVideoView"
      >
        <div>
          <openBar />
          <leftBar
            :isFollow="isFollow"
            :countObj="countObj"
            :memo='memo'
            @clickLike="$openApp"
            @clickComment="$openApp"
            @clickShare="$openApp"
            @clickAdd="$openApp"
            @clickAvatar="clickAvatar"
          />
        </div>

      </player>
      <videoList />
    </div>

    <videoDel v-else />
  </div>
</template>

<script>
/* eslint-disable import/no-cycle */
import { mapActions } from 'vuex';
import { apiGetVideoInfo, apiReportVideoView } from '@/api/home';
import { apiIsFollowUser } from '@/api/app/video/index';

import openBar from '@/components/open-bar/index.vue';
import leftBar from '@/components/video/left-bar/index.vue';
import videoDel from './video-del/index.vue';
import videoList from './video-list/index.vue';

export default {
  data() {
    return {
      iscover: false,
      isFollow: false,
      countObj: {},
      memo: '',
      timer: null,
      viewTime: 0,
      isVideoDel: false,
      playUrl: '',
      coverUrl: '',
    };
  },
  components: {
    videoList,
    openBar,
    leftBar,
    videoDel,
  },
  methods: {
    // 点击用户头像
    clickAvatar() {
      this.$store.commit('noKeepAlive', 'userCenter');
      const { liveVideoId, liveState } = this.$store.state.userInfo;
      // 正在直播
      if (liveState === 1) {
        this.$router.push({
          path: 'live',
          query: {
            userId: this.$route.query.userId,
            snowId: liveVideoId,
          },
        });
      } else {
        this.$router.push({
          path: 'userCenter',
          query: {
            userId: this.$route.query.userId,
          },
        });
      }
    },
    ...mapActions({
      getUserInfo: 'getUserInfo',
    }),
    // 播放时间上报
    reportVideoView(isEnd = false) {
      const { snowId } = this.$route.query;
      this.viewTime += 5;
      let { viewTime } = this;
      if (isEnd) {
        viewTime = document.querySelector('video').currentTime.toFixed(1);
      }
      apiReportVideoView({
        isEnd,
        snowId,
        viewTime,
        channel: window.sessionStorage.getItem('channel'),
      });
    },
    // 清除上报
    clearReportVideoView() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // 视频播放
    playerPlay() {
      this.timer = setInterval(() => {
        this.reportVideoView();
      }, 5000);
    },
    // 播放结束
    playerEnd() {
      this.clearReportVideoView();
      this.reportVideoView(true);
      this.viewTime = 0;
    },
    init() {
      const { snowId, userId } = this.$route.query;
      apiIsFollowUser({ followedUid: userId })
        .then((res) => {
          this.isFollow = res.data && res.data.isFollow;
        });
      Promise.all([this.getUserInfo({ userId }), apiGetVideoInfo({ snowId })]).then((res) => {
        this.$NProgress.done();
        // 视频被删除了
        if (res[1].data === 19) {
          this.isVideoDel = true;
        }
        const {
          pvCount, forwardCount, pointupCount, commentCount, memo, playUrl, coverUrl,
          width, height,
        } = res[1].data;

        this.memo = memo;
        this.countObj = {
          pvCount, forwardCount, pointupCount, commentCount,
        };
        this.playUrl = playUrl;
        this.coverUrl = coverUrl;
        if (width / height === 9 / 16) {
          this.iscover = true;
        }
      }).catch((res) => {
        if (res.code === 19) {
          this.isVideoDel = true;
        } else {
          this.$toast({
            message: res.message,
          });
        }
      });
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.clearReportVideoView();
  },
};
</script>
<style lang="less">
#homePlayer{
  position: relative;
  .player {
    height: 100vh;
    #wy-player {
      height: 100%;
    }
  }
}
</style>
